// extracted by mini-css-extract-plugin
export default {"table-sort-and-filter-footer":"sortAndFilterFooter-module__table-sort-and-filter-footer__STYDd"};